import { XDActions } from '../../xd/actions'
import { IXDRequest, XDRequest } from '../../xd/request'
import { Store } from '../keys'

/**
 * Cross-domain storage request. Adds expiry and key.
 */
export interface IXDStorageRequest<T> extends IXDRequest<T> {
    exp?: number
    key?: Store
}

export class XDStorageRequest<T> extends XDRequest<T> implements IXDStorageRequest<T> {

    constructor(
        public readonly action: XDActions,
        public readonly key?: Store,
        public data?: T,
        public readonly exp?: number,
        public readonly ts = Date.now(),
        hash?: number
    ) {
        super(action, data, ts, hash)
        this.updateHash(hash)
    }
}
